import { map } from "lodash";
import { Img } from "../ImgV2/Img";
import { useSignal } from "@preact/signals-react";
import React, { useCallback, useEffect, useMemo } from "react";
import { SwitchTab } from "../components/SwitchTab/SwitchTab";
import styles from "./NewsDigestDetails.module.scss";
export function NewsDigestDetails(props) {
  var _props$news_details_f, _current$value;
  var activeKey = useSignal((_props$news_details_f = props.news_details_feed[0]) === null || _props$news_details_f === void 0 ? void 0 : _props$news_details_f.news_category_title);
  var current = useSignal(props.news_details_feed[0]);
  var tabList = useMemo(function () {
    return props.news_details_feed.map(function (item) {
      return {
        name: item.news_category_title,
        key: item.news_category_title
      };
    });
  }, [props.news_details_feed]);
  var setActiveKey = useCallback(function (key) {
    if (key === activeKey.value) return;
    activeKey.value = key;
    var seasonal = props.news_details_feed.find(function (x) {
      return x.news_category_title === key;
    });
    if (seasonal) {
      current.value = seasonal;
    }
  }, [props.news_details_feed]);
  useEffect(function () {
    var _props$news_details_f2, _props$news_details_f3;
    activeKey.value = (_props$news_details_f2 = props.news_details_feed[0]) === null || _props$news_details_f2 === void 0 ? void 0 : _props$news_details_f2.news_category_title;
    current.value = (_props$news_details_f3 = props.news_details_feed) === null || _props$news_details_f3 === void 0 ? void 0 : _props$news_details_f3[0];
  }, [props.news_details_feed]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SwitchTab, {
    list: tabList,
    activeKey: activeKey,
    setActiveKey: setActiveKey
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.listBody
  }, map((_current$value = current.value) === null || _current$value === void 0 ? void 0 : _current$value.news_category_detail, function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.news,
      key: index
    }, item.news_source_icon ? /*#__PURE__*/React.createElement(Img, {
      className: "imageNewsGridImg",
      imgKey: item.news_source_icon
    }) : /*#__PURE__*/React.createElement("div", {
      className: styles.newsBox
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.title
    }, item.news_title), /*#__PURE__*/React.createElement("div", {
      className: styles.timestamp
    }, /*#__PURE__*/React.createElement("img", {
      className: styles.categoryTag,
      src: item.category_tag,
      alt: ""
    }), /*#__PURE__*/React.createElement("span", {
      className: styles.categoryText
    }, item.time_posted))));
  })));
}